import { render, staticRenderFns } from "./DialogCadastroSaldoRacao.vue?vue&type=template&id=1a5e1c99&scoped=true&"
import script from "./DialogCadastroSaldoRacao.vue?vue&type=script&lang=js&"
export * from "./DialogCadastroSaldoRacao.vue?vue&type=script&lang=js&"
import style0 from "./DialogCadastroSaldoRacao.vue?vue&type=style&index=0&id=1a5e1c99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e1c99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VForm,VLayout,VTextField})
